/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExportUrlDto,
    ExportUrlDtoFromJSON,
    ExportUrlDtoFromJSONTyped,
    ExportUrlDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExportsResponse
 */
export interface ExportsResponse {
    /**
     * 
     * @type {Array<ExportUrlDto>}
     * @memberof ExportsResponse
     */
    all: Array<ExportUrlDto>;
    /**
     * 
     * @type {number}
     * @memberof ExportsResponse
     */
    totalCount: number;
}

export function ExportsResponseFromJSON(json: any): ExportsResponse {
    return ExportsResponseFromJSONTyped(json, false);
}

export function ExportsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all': ((json['all'] as Array<any>).map(ExportUrlDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function ExportsResponseToJSON(value?: ExportsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all': ((value.all as Array<any>).map(ExportUrlDtoToJSON)),
        'totalCount': value.totalCount,
    };
}


